import { Trip } from "@fairfleet/geotab";

/**
 * Trips driven within the stay, in order. The trip that leaves the zone starts inside the stay but ends
 * outside (live fairfleet 2026-11-04: 52.7 km), so a trip must also stop before the exit.
 */
export function tripsInStay(trips: Trip[], entry: Date, until: Date): Trip[] {
  return trips
    .filter(trip => {
      const start = new Date(trip.start);
      const stop = new Date(trip.stop);
      return start >= entry && stop <= until;
    })
    .sort((a, b) => new Date(a.start).getTime() - new Date(b.start).getTime());
}
